import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { Page } from '../page.dto';

/**
 * The condition-backed task cards on the clinical dashboard. Each has a dedicated legacy route
 * (`GET /tasks/<kebab-case name>-task`); `GET /tasks/condition-tasks` answers any combination of
 * them in one request.
 */
export enum ConditionTaskType {
  TeleReferral = 'teleReferral',
  Draft = 'draft',
  Biopsy = 'biopsy',
  OverdueFollowUp = 'overdueFollowUp',
}

/** One page per requested card; a card that was not requested is absent. */
export type ConditionTasksDto = Partial<
  Record<ConditionTaskType, Page<TaskFilterDto>>
>;

export class TaskFilterDto {
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  conditionId?: string;

  /** @deprecated Use conditionId */
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  lesionId?: string;

  @IsString()
  @IsNotEmpty()
  healthRecordId: string;
}

export interface TaskDto {
  teleReferralTasks: Page<TaskFilterDto>;
  biopsyTasks: Page<TaskFilterDto>;
  followupTasks: Page<TaskFilterDto>;
  pendingAnnotationsTasks: Page<string>;
  annotationsFeedbackTasks: Page<string>;
  annotationsForReviewTasks: Page<string>;
}
